import { writable } from "svelte/store";
import { fetchWithSession } from "../util/fetchWithSession";

export function createApplicationLimitationPresetsStore() {
  const { subscribe, set, update } = writable({
    applicationLimitationPresets: [],
    applicationLimitationPresetsType: "",
    currentApplicationLimitationPresets: {},
    applicationLimitationModalOpen: false,
  });

  async function getApplicationLimitationPresets(idlimitationpreset) {
    try {
      const res = await fetchWithSession(
        `/api/damprojects/limitation-presets/${idlimitationpreset}`
      );
      if (!res?.ok) return;
      const data = await res.json();
      update((state) => ({
        ...state,
        applicationLimitationPresets: data.items,
        applicationLimitationPresetsType: data.type,
      }));
    } catch (err) {
      console.log(err);
    }
  }

  function addApplicationPresets(addedApplications) {
    if (addedApplications.length > 0) {
      addedApplications.forEach((application) => {
        saveApplicationLimitationItem(application);
      });
      addedApplications = [];
    }
  }

  async function saveApplicationLimitationPresetItem(
    currentApplicationLimitationPresets,
    idlimitationpreset
  ) {
    const { id, ...applicationData } = currentApplicationLimitationPresets;
    const isUpdate = id && id !== null && id !== undefined;

    let payload = {
      idlimitationpreset: idlimitationpreset,
      ...applicationData,
    };
    console.log("saveApplicationLimitationPresetItem", { payload });
    try {
      const response = await fetchWithSession(
        isUpdate
          ? `/api/damprojects/limitation-preset-items/${id}`
          : `/api/damprojects/limitation-preset-items`,
        {
          method: isUpdate ? "PATCH" : "POST",
          body: JSON.stringify(payload),
        }
      );
      if (!response?.ok) return; // fetchWrapper already toasted the error
      const res = await response.json();
      if (res.error) {
        return;
      }
      const data = res.data;
      if (data.id !== currentApplicationLimitationPresets.id) {
        const newApplicationLimitation = {
          ...currentApplicationLimitationPresets,
          id: data.id,
        };
        update((state) => ({
          ...state,
          applicationLimitationPresets: [
            ...state.applicationLimitationPresets,
            newApplicationLimitation,
          ],
        }));
      } else {
        update((state) => ({
          ...state,
          applicationLimitationPresets: state.applicationLimitationPresets.map(
            (x) =>
              x.id === currentApplicationLimitationPresets.id
                ? currentApplicationLimitationPresets
                : x
          ),
        }));
      }
      update((state) => ({
        ...state,
        applicationLimitationModalOpen: false,
      }));
    } catch (err) {
      // fetchWrapper already toasted the network error
      console.log(err);
    }
  }

  async function updateDAMLimitation(
    idlimitationpreset,
    applicationLimitationPresetsType
  ) {
    try {
      const response = await fetchWithSession(
        `/api/damprojects/limitation-presets/${idlimitationpreset}`,
        {
          method: "PATCH",
          body: JSON.stringify({ type: applicationLimitationPresetsType }),
        }
      );
      if (!response?.ok) return; // fetchWrapper already toasted the error
      const res = await response.json();
      if (res.error) {
        return;
      }
    } catch (err) {
      console.log(err);
    }
  }

  function editApplicationLimitationPresetItem(id) {
    console.log({ id });
    let currentApplicationLimitationPresets = {
      id: null,
      isbrowser: 0,
      name: "",
      appname: "",
      windowtitle: "",
      url: "",
    };
    update((state) => ({
      ...state,
      currentApplicationLimitationPresets:
        id !== 0
          ? { ...state.applicationLimitationPresets.find((x) => x.id === id) }
          : currentApplicationLimitationPresets,
      applicationLimitationModalOpen: true,
    }));
  }

  async function deleteApplicationLimitationPreset(id) {
    try {
      const res = await fetchWithSession(
        `/api/damprojects/limitation-preset-items/${id}`,
        {
          method: "DELETE",
        }
      );
      if (!res?.ok) return; // fetchWrapper already toasted the error
      const data = await res.json();
      if (data.error) {
        return;
      }
      update((state) => ({
        ...state,
        applicationLimitationPresets: state.applicationLimitationPresets.filter(
          (x) => x.id !== id
        ),
      }));
    } catch (err) {
      // fetchWrapper already toasted the network error
      console.log(err);
    }
  }

  function closeModal() {
    update((state) => ({
      ...state,
      applicationLimitationModalOpen: false,
    }));
  }

  

  return {
    subscribe,
    getApplicationLimitationPresets,
    addApplicationPresets,
    saveApplicationLimitationPresetItem,
    updateDAMLimitation,
    editApplicationLimitationPresetItem,
    deleteApplicationLimitationPreset,
    closeModal
  };
}

export const applicationLimitationPresetsStore =
  createApplicationLimitationPresetsStore();
